import _ from "lodash";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { campaigns, products, brands } from "data/actions";
import MenuLink from "components/Navigation/MenuLink";

import { Page, PageBlock, RightDrawer } from "components/Page";
import Price from "components/Formaters/Price";
import Percent from "components/Formaters/Percent";
import Delete from "components/Buttons/Delete";
import * as os from "osutil";

import Subheader from "material-ui/Subheader";
import RaisedButton from "material-ui/RaisedButton";

class ReportsPage extends Component {
  state = {};

  static contextTypes = {
    router: PropTypes.object
  };

  componentWillMount() {
    this.props.actions.fetchProducts();
    this.props.actions.fetchCampaigns(this.props.user.accountid);
  }

  handleDeleteClick(id) {
    this.props.actions.deleteCampaign(this.props.user.accountid, id);
  }

  handleEditClick = id => {
    this.context.router.history.push("/rapporter/" + id);
  };


  renderCampaigns = campaigns => {
    if (!campaigns || campaigns.length === 0) {
      return <span className="campaign_empty">Inga kampanjer</span>;
    }

    return _.map(campaigns, (campaign, key) => {
      var count = campaign.bookings ? Object.keys(campaign.bookings).length : 0;
      var amount = campaign.details.amount ? campaign.details.amount : 0;
      var revenue = campaign.details.revenue ? campaign.details.revenue : 0;
      var roi = revenue && amount ? Math.floor( 100 * ( revenue - amount ) / amount ) : 0;
      console.log(revenue , amount, revenue - amount, roi);
      var cln = roi < 0 ? 'campaigns_row campaigns_row__negative_roi':'campaigns_row';
      return (
        <div
          className={cln}
          key={key}
          onClick={this.handleEditClick.bind(this, campaign.key)}
        >
          <span className="campaign_row_name">{campaign.details.name}</span>
          <span className="campaign_row_">{count} annonser</span>
          <span className="campaign_row_">

          <Price value={amount} />
          </span>
          <span className="campaign_row__roi">
          {roi ? <Percent value={""+roi} /> : null} 
          </span>
          
        </div>
      );
    });
  };
  render() {
    return [
      <RightDrawer key="brand_right">
        <PageBlock label="Rapporter">
          <p>Här bredvid presenteras en sammanställning över de kampanjer som genomförts i ditt konto. Klicka på någon av kampanjerna för en mer detaljerad rapport. Observera att du behöver gå in på kampanjen och fylla i intäkter från kampanjen för att avkastning på investering/ROI skall kunna räknas fram.  </p>
        </PageBlock>
      </RightDrawer>,
      <Page key="page" ready={!this.props.pending}>

        <PageBlock label="Rapporter" header={true} className="campaigns_list">
            <div className="campaigns_row campaigns_row_header">
              <span className="campaign_row_name">Kampanj</span>
              <span className="campaign_row_">Annonser</span>
              <span className="campaign_row_">Investering</span>
              <span className="campaign_row_">Avkastning/ROI</span>
            </div>
          {this.renderCampaigns(this.props.completed)}
        </PageBlock>
      </Page>
    ];
  }
}

function mapStateToProps(state) {
  if (!state.products.list.data) {
    return {};
  }
  var list = os.collection_to_array(state.campaigns.list.data);
  return {
    campaigns: list,
    completed: _.filter(list, c => c.details.status === "completed"),
    products: state.products.list.data,
    user: state.auth.user,
    pending: state.campaigns.list.pending
  };
}

const mapDispatch = dispatch => {
  return {
    actions: bindActionCreators(
      { ...products, ...campaigns, ...brands },
      dispatch
    )
  };
};

export default connect(mapStateToProps, mapDispatch)(ReportsPage);



// WEBPACK FOOTER //
// ./src/pages/campaigns/Reports.jsx